/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useToast } from "../../../../context/toast-context";
import useAPIHandler from "../../../../hook/use-api-handler";
import { EMPTY_TAX_SLAB, PTAX_INITIAL_STATE } from "./p-tax-constant";

const usePTaxServiceNew = () => {
    const [allStateList, setAllStateList] = useState([])
    const [adminPTaxModal, setAdminPTaxModal] = useState(false)
    const [adminPTaxUiLoading, setAdminPTaxUiLoading] = useState(false);
    const [formUpdateLoading, setFormUpdateLoading] = useState(false)
    const [adminPTaxData, setAdminPTaxData] = useState([])
    const [adminPtaxInputs, setadminPtaxInputs] = useState(structuredClone(PTAX_INITIAL_STATE))
    const [errors, setErrors] = useState([])
    const { showToastMessage } = useToast();
    const adminPTaxModalOpen = () => {
        setAdminPTaxModal(true)
    }
    const adminPTaxModalClose = () => {
        setAdminPTaxModal(false)
    }

    const resetForm = () => {
        setErrors({})
        setadminPtaxInputs(structuredClone(PTAX_INITIAL_STATE))
    }
    const handleClickOpenEditModal = (data) => {
        adminPTaxModalOpen()
        // const {session,...restData}=data;
        // if(session){
        //     const[year,to_year]=session.split("-");
        //     setadminPtaxInputs({
        //         ...restData,
        //         year,
        //         to_year
        //     });
        // }else{
        //     setadminPtaxInputs({ ...data });
        // }
        // setadminPtaxInputs({...data})
        const { year, to_year, ...restData } = data;
        const session = year && to_year ? `${year}-${to_year}` : "";
        setadminPtaxInputs({
            ...restData,
            year,
            to_year,
            session,

        });
    }
    const handleClickOpenAddModal = () => {
        adminPTaxModalOpen()
        resetForm()
    }

    const { fetchData } = useAPIHandler()
    const getAllState = async () => {
        setAdminPTaxUiLoading(true)
        try {
            const response = await fetchData({
                url: '/common/state',
                method: 'GET'
            });
            setAdminPTaxUiLoading(false)
            // logger.log(response)
            const responseState = response?.data?.map(item => ({
                id: item?.state_id,
                name: item?.state_name
            }))
            setAllStateList(responseState)

        } catch {
            setAdminPTaxUiLoading(false)
        }
    }
    const getAllPTaxData = async () => {
        setAdminPTaxUiLoading(true)
        try {
            const response = await fetchData({
                url: '/admin/p-tax',
                method: 'GET'
            });
            setAdminPTaxUiLoading(false)
            // logger.log(response)
            setAdminPTaxData(response?.data)

        } catch {
            setAdminPTaxUiLoading(false)
        }


    }
    const handleChange = (e, name) => {
        let value = e;
        if (e & e.target) {
            value = e.target.value;
            name = e.target.name
        }
        if (name === "session") {
            const [startYear, endYear] = value.split("-");
            setadminPtaxInputs((prevInfo) => ({
                ...prevInfo,
                year: startYear,
                to_year: endYear

            }));
        } else {
            setadminPtaxInputs((prevInfo) => ({
                ...prevInfo,
                [name]: value
            }))
        }
    }
    const handleAddPTax = async () => {
        setFormUpdateLoading(true);
        const {
            year,
            to_year,
            state_id,
            tax_cal

        } = adminPtaxInputs || {}
        try {
            const url = adminPtaxInputs?.ptax_id ? `/admin/modify-ptax/${adminPtaxInputs?.ptax_id}` : "/admin/p-tax"
            const response = await fetchData({
                url: url,
                method: "POST",
                data: {
                    state_id: Number(state_id),
                    year:year || adminPtaxInputs.year,
                    to_year:to_year || adminPtaxInputs.to_year,
                    // tax_cal:tax_cal.map(slab=>({
                    //     min_salary: Number(slab.min_salary),
                    //     max_salary: slab.max_salary ? Number(slab.max_salary) : null,
                    //     tax_amount: Number(slab.tax_amount)
                    // }))
                    tax_cal: tax_cal.map(slab => {
                        const { min_salary, max_salary, tax_amount } = slab;
                        const taxData = {
                            min_salary: Number(min_salary),
                            tax_amount: Number(tax_amount),
                        };
                        if (max_salary) {
                            taxData.max_salary = Number(max_salary);
                        }
                        return taxData;
                    }),
                }
            });
            setFormUpdateLoading(false);
            getAllPTaxData();
            adminPTaxModalClose()
            showToastMessage({
                message: adminPtaxInputs?.ptax_id ?
                    "P-Tax updated successfully!" :
                    "P-Tax created successfully!",
                color: "success"
            });

        } catch (error) {
            // setFormUpdateLoading(false)
            if (error?.type === "JoiValidationError") {
                const errorsAll = {};
                error?.errors?.map((item) => {
                    const { field, message } = item;
                    errorsAll[field] = message;
                });

                showToastMessage({
                    message:
                        Object.keys(errorsAll).length > 0
                            ? "Validation Error!"
                            : "Something went wrong!",
                    color: "danger",
                });
                setErrors(errorsAll);
            }

            if (error?.type === "GeneralError") {
                showToastMessage({
                    message: error.message || "An unknown general error occurred.",
                    color: "danger",
                });
            }
            setFormUpdateLoading(false);
            // adminPTaxModalClose()
        }

    }

    const handleAddTaxSlab = () => {
        setadminPtaxInputs(prev => {
            const lastSlabIndex = prev.tax_cal.length - 1;
            const lastSlab = prev.tax_cal[lastSlabIndex]
            const newMinSalary = lastSlab.max_salary ? String(Number(lastSlab.max_salary) + 1) : "";
            return {
                ...prev,
                tax_cal: [
                    ...prev.tax_cal,
                    {
                        ...EMPTY_TAX_SLAB,
                        min_salary: newMinSalary
                    }
                ]
            }
        })
    }

    const handleTaxSlabChange = (value, field, index) => {
        setadminPtaxInputs(prev => ({
            ...prev,
            tax_cal: prev.tax_cal.map((slab, i) =>
                i == index ? { ...slab, [field]: value } : slab
            )
        }));
    }
    const handleRemoveTaxSlab = (index) => {
        setadminPtaxInputs(prev => ({
            ...prev,
            tax_cal: prev.tax_cal.filter((_, i) => i !== index)
        }));
    };

    useEffect(() => {
        getAllPTaxData();
        getAllState()
    }, [])
    return {
        adminPTaxData,
        adminPTaxModal,
        adminPTaxModalOpen,
        adminPTaxModalClose,
        handleChange,
        errors,
        allStateList,
        adminPtaxInputs,
        handleAddTaxSlab,
        handleTaxSlabChange,
        handleRemoveTaxSlab,
        handleAddPTax,
        formUpdateLoading,
        handleClickOpenEditModal,
        handleClickOpenAddModal
    }
}

export default usePTaxServiceNew
